module.exports = __webpack_public_path__ + "img/harnessing_water_power.55ec3dd4.png";